export default __webpack_public_path__ + "static/logo-51e7903178c97b17626c5c36e32ac7b1.svg";